import { Pipe, PipeTransform } from '@angular/core';
import { UserProfile, userProfileHelpers } from '@content-platform/web-angular-administration-shared-data-access-graph-api';

@Pipe({ name: 'displayName' })
export class DisplayNamePipe implements PipeTransform {
  transform(userObj: UserProfile | adal.User, expanded = false): string {
    if (!userObj) {
      return '';
    }
    return userProfileHelpers.getDisplayName(userObj, {
      addEmail: expanded,
      addUserTypeIfExternal: true
    });
  }
}
